import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { clientsApi } from "@/api";
import Header from "@/components/Header";

const AddClientScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.first_name || !formData.last_name || !formData.email || !formData.phone) {
      alert(t('common.fillAllFields'));
      return;
    }

    setLoading(true);
    try {
      await clientsApi.create(formData);
      alert(t('clients.clientCreated'));
      navigate('/');
    } catch (error) {
      alert(t('clients.clientCreationError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 pb-20 md:pt-16">
      <Header title={t('clients.newClient')} showBack />
      
      <div className="max-w-lg mx-auto p-4">
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">{t('clients.firstName')} *</label>
            <input
              type="text"
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              placeholder="Mario"
              value={formData.first_name}
              onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
              data-testid="input-first-name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">{t('clients.lastName')} *</label>
            <input
              type="text"
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              placeholder="Rossi"
              value={formData.last_name}
              onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
              data-testid="input-last-name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">{t('clients.email')} *</label>
            <input
              type="email"
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              placeholder="mario@email.com"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              data-testid="input-email"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">{t('clients.phone')} *</label>
            <input
              type="tel"
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              placeholder="+39 333 1234567"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              data-testid="input-phone"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-indigo-600 text-white py-3 rounded-xl font-semibold hover:bg-indigo-700 transition-colors disabled:bg-gray-400"
            data-testid="submit-client"
          >
            {loading ? t('common.saving') : t('clients.saveClient')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddClientScreen;
